import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Mettre à jour l'état pour que le prochain rendu affiche l'UI de repli
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Logger l'erreur pour le débogage
    console.error('❌ [ErrorBoundary] Erreur capturée:', error, errorInfo);
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
    
    // Optionnel : envoyer l'erreur à un service de logging
    // logErrorToService(error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  handleClearCache = () => {
    try {
      localStorage.clear();
      sessionStorage.clear();
      // Désactiver les service workers
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.getRegistrations().then((registrations) => {
          registrations.forEach((registration) => {
            registration.unregister();
          });
        });
      }
      window.location.reload();
    } catch (e) {
      console.error('Erreur lors du nettoyage du cache:', e);
      window.location.reload();
    }
  };

  render() {
    if (this.state.hasError) {
      // Fallback personnalisé (ex. barre minimale dans le header)
      if (this.props.fallback) {
        return this.props.fallback;
      }
      // UI de repli complète
      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          padding: '20px',
          backgroundColor: 'var(--bg-primary)',
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
        }}>
          <div style={{
            maxWidth: '600px',
            width: '100%',
            backgroundColor: 'var(--surface)',
            padding: '30px',
            borderRadius: '8px',
            boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
          }}>
            <h1 style={{ 
              color: '#d32f2f', 
              marginTop: 0,
              marginBottom: '20px',
              fontSize: '24px'
            }}>
              ⚠️ Une erreur s'est produite
            </h1>
            
            <p style={{ 
              color: '#666', 
              marginBottom: '10px',
              lineHeight: '1.6'
            }}>
              L'application a rencontré une erreur inattendue. Veuillez essayer de recharger la page.
            </p>
            <p style={{ color: '#888', fontSize: '14px', marginBottom: '20px', lineHeight: '1.5' }}>
              Après une mise à jour de l'application, essayez d'abord « Vider le cache et recharger ».
            </p>

            {this.state.error && (
              <details open style={{
                marginBottom: '20px',
                padding: '15px',
                backgroundColor: '#f9f9f9',
                borderRadius: '4px',
                fontSize: '12px',
                fontFamily: 'monospace'
              }}>
                <summary style={{ 
                  cursor: 'pointer', 
                  marginBottom: '10px',
                  fontWeight: 'bold',
                  color: '#333'
                }}>
                  Détails techniques (pour le débogage)
                </summary>
                <div style={{ 
                  whiteSpace: 'pre-wrap', 
                  wordBreak: 'break-word',
                  color: '#d32f2f'
                }}>
                  {this.state.error.toString()}
                  {this.state.errorInfo && (
                    <div style={{ marginTop: '10px', color: '#666' }}>
                      {this.state.errorInfo.componentStack}
                    </div>
                  )}
                </div>
              </details>
            )}

            <div style={{
              display: 'flex',
              gap: '10px',
              flexWrap: 'wrap'
            }}>
              <button
                onClick={this.handleReload}
                style={{
                  padding: '12px 24px',
                  backgroundColor: '#1976d2',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontSize: '16px',
                  fontWeight: '500'
                }}
              >
                🔄 Recharger la page
              </button>
              
              <button
                onClick={this.handleClearCache}
                style={{
                  padding: '12px 24px',
                  backgroundColor: '#f57c00',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontSize: '16px',
                  fontWeight: '500'
                }}
              >
                🗑️ Vider le cache et recharger
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;

